<template>
  <div id="NewDeviceUploadForm">
    <form action>
      <div class="modal-card fixed-width dtac-font">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t("devices.form.title") }}</p>
        </header>
        <section class="modal-card-body">
          <div class="media">
            <div class="media-content">
              <p class="subtitle is-6">{{ $t("devices.form.info") }}</p>
              <b-field>
                <b-input
                  type="textarea"
                  v-model="textToUpload"
                  :placeholder="$t('devices.form.placeholder')"
                ></b-input>
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <button class="button dtac-font" @click.prevent="$emit('close')">
            {{ $t("register.form.otp.close_btn") }}
          </button>
          <button
            class="button is-primary dtac-font"
            @click.prevent="confirmUploadNewDevices"
          >
            {{ $t("register.form.otp.confirm_btn") }}
          </button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import AlertManager from "@/managers/AlertManager";
import DeviceApiManager from "@/apis/DeviceApiManager";

export default {
  name: "NewDeviceUploadForm",
  data() {
    return {
      textToUpload: null
    };
  },
  methods: {
    confirmUploadNewDevices: function() {
      let newDeviceListParams = [];

      if (this.textToUpload && this.textToUpload != "") {
        // Remove all space occured in the input text
        let nospaceString = this.textToUpload.replace(/ /g, "");
        // Split by newline which each will contains device info "msisdn,imei,esn"
        const deviceInfoList = nospaceString.split("\n");
        deviceInfoList.forEach(device => {
          // Split by comma (,) which length sould be 3 [ msisdn, imei, esn ]

          let deviceParams = {};
          const info = device.split(",");
          switch (info.length) {
            case 3:
              deviceParams = {
                msisdn: info[0],
                imei: info[1],
                esn: info[2],
                telp_type: "T"
              };
              break;
            case 4:
              deviceParams = {
                msisdn: info[0],
                imei: info[1],
                esn: info[2],
                telp_type: info[3]
              };
              break;
            default:
              break;
          }
          newDeviceListParams.push(deviceParams);
        });
        this.uploadNewDevicesInfo(newDeviceListParams);
      } else {
        AlertManager.showErrorSnackbar("Please input device infomation");
      }
    },
    uploadNewDevicesInfo: async function(batch) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const uploadResult = await DeviceApiManager.requestCreateNewDevices(
        batch
      );
      loadingComponent.close();
      switch (uploadResult.code) {
        case "0":
          if (uploadResult.data.failed > 0) {
            AlertManager.showErrorSnackbar(
              "Failed Upload " + uploadResult.data.failed + " New Devices"
            );
          } else {
            this.$emit("completed_upload_new_devices", uploadResult.data);
            AlertManager.showSuccessSnackbar("Upload New Devices Successfully");
          }
          break;

        default:
          this.$buefy.dialog.alert({
            title: "Error",
            message: uploadResult.message,
            type: "is-danger",
            hasIcon: true
          });
          // AlertManager.showErrorSnackbar(uploadResult.message);
          break;
      }
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 680px;
  padding: 0 20px;
}
</style>
